import React from "react";

export default function PromoTwo() {
  return (
    <>
      <section className="promo-section mt-5 ptb-100" id={'caracteristicas'}>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-10">
              <div className="section-heading mb-5">
                <span className="text-uppercase color-secondary sub-title">
                  Características clave
                </span>
                <h2 className="mb-6">
                  Te ayudaremos a construir aplicaciones increíbles
                </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-sm-6 mb-lg-0">
              <div className="card single-promo-card single-promo-hover">
                <div className="card-body">
                  <div className="pb-2">
                    <span className="ti-layout icon-md color-secondary"></span>
                  </div>
                  <div className="pt-2 pb-3">
                    <div className={'h5'}>Análisis</div>
                    <p className="text-muted mb-0">
                      Realiza un seguimiento de tus aplicaciones y obtén información valiosa.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="card single-promo-card single-promo-hover mb-lg-0">
                <div className="card-body">
                  <div className="pb-2">
                    <span className="ti-control-record icon-md color-secondary"></span>
                  </div>
                  <div className="pt-2 pb-3">
                    <div className={'h5'}>Adaptado</div>
                    <p className="text-muted mb-0">
                      Optimizado para funcionar en la mayoría de los dispositivos.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="card single-promo-card single-promo-hover mb-lg-0">
                <div className="card-body">
                  <div className="pb-2">
                    <span className="ti-vector icon-md color-secondary"></span>
                  </div>
                  <div className="pt-2 pb-3">
                    <div className={'h5'}>Escalable</div>
                    <p className="text-muted mb-0">
                      Creamos aplicaciones de cualquier tamaño con facilidad.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="card single-promo-card single-promo-hover mb-lg-0">
                <div className="card-body">
                  <div className="pb-2">
                    <span className="ti-receipt icon-md color-secondary"></span>
                  </div>
                  <div className="pt-2 pb-3">
                    <div className={'h5'}>Personalizable</div>
                    <p className="text-muted mb-0">
                      Cambia el aspecto de tu aplicación con facilidad y rapidez.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
